import { css } from 'linaria';
import { styled } from 'linaria/react';

export const root = css`
  position: relative;
`;

export const menu = css`
  display: flex;
  flex-direction: column;
  width: 300px;
`;

export const badge = css`
  position: absolute;
  top: 0;
  right: 1px;
`;

export const ProIconWrapper = styled.div`
  svg {
    position: absolute;
    top: 0;
    right: -7px;
  }
`;
